import React from 'react'
import KibLabel from '@chewy/kib-label-react'

import {
  type RxDisplayStatus,
  RxDisplayStatusLabel,
  RxDisplayStatusToVariant,
} from '~/constants/rxStatusChip'

import '@chewy/kib-label-styles/dist/kib-label.css'

export interface RxStatusChipProps {
  className?: string
  status: RxDisplayStatus
}

export const RxStatusChip = ({ status, className }: RxStatusChipProps) => {
  const variant = RxDisplayStatusToVariant[status]
  const label = RxDisplayStatusLabel[status]

  return (
    <KibLabel className={className} variant={variant}>
      {label}
    </KibLabel>
  )
}

export default RxStatusChip
